import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Collapse,
  Dropdown,
  Form,
  Image,
  Row,
} from "react-bootstrap";
import { StyledButton } from "../../styles/StyledCDButton";

import {
  faArrowDown,
  faArrowUp,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import restrictionDownArrow from "../../assets/images/restrictionDownArrow.svg";
import restrictionUpArrow from "../../assets/images/restrictionUpArrow.svg";

import LeftArrow from "../../assets/images/leftArrow.png";
import logoupdated from "../../assets/images/logoupdated.svg";
import RightArrow from "../../assets/images/rightArrow.png";
import starYellow from "../../assets/images/starYellow.png";
import UpDownSorting from "../../assets/images/upDownSorting.png";

import { StyledCustomCard } from "../../styles/StyledCustomCard";
import { trackEvent } from "../../utils/analytics";
import {
  clickTrack,
  formatBalance,
  formateDate,
  formatRating,
  formatTerms,
  redirectToNewTab,
} from "../../utils/common";
import { APY_TEXT, EST_TEXT, USERDEV_BASE_URL } from "../../utils/constant";
import OpenNowButton from "../OpenNowButton";
import Tooltip from "../Tooltip";
import { NoRecordSection } from "./NoRecordSection";

const months = {
  0: "Jan",
  1: "Feb",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December",
};

export const termOptions = [
  { value: 6, label: "6 month" },
  { value: 12, label: "12 month" },
  { value: 24, label: "24 month" },
  { value: 36, label: "36 month" },
  { value: 48, label: "48 month" },
  { value: 60, label: "60 month" },
];

export const sortData = [
  { "APY (DSC)": { sort: "byApy", order: "DESC" } },
  { "APY (ASC)": { sort: "byApy", order: "ASC" } },
  { "Terms (DSC)": { sort: "byTerm", order: "DESC" } },
  { "Terms (ASC)": { sort: "byTerm", order: "ASC" } },
  { "Min. Deposit (DSC)": { sort: "byBalance", order: "DESC" } },
  { "Min. Deposit (ASC)": { sort: "byBalance", order: "ASC" } },
  { "Est. Earnings (DSC)": { sort: "byEarning", order: "DESC" } },
  { "Est. Earnings (ASC)": { sort: "byEarning", order: "ASC" } },
];

const redirectClick = async (data,affiliateId) => {
    const redirectURL = `${USERDEV_BASE_URL}bankDetails/${data?.bankName?.replaceAll(
      " ",
      "-"
    )}/${data?.bankId ? data?.bankId : data?._id}`;

    const response = await clickTrack(data, redirectURL);
    const finalUrl=response?.data?.redirectUrl
    if(finalUrl){
      redirectToNewTab(finalUrl);
    }
    trackEvent("Affiliate_FI_View_Details_Action", { ...data, affiliateId });
  };

export const HeaderContent = ({
  showLogo = true,
  apyPerecentage,
  logoClick,
}) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = months[date.getMonth()];
  const parsedApy = parseFloat(apyPerecentage);
  const formattedApy = !isNaN(parsedApy)
    ? parsedApy.toFixed(2)
    : apyPerecentage;

  return (
    <section className="p-6 rounded-lg shadow-md header-wrapper">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-2xl font-bold font-weight-700 mb-4 mt-4 header-content">
          Best CD Rates of {month} {year} - Up to {formattedApy}%
        </h2>
        {showLogo && (
          <a
            href={USERDEV_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={logoClick}
          >
            <Image
              src={logoupdated}
              height={50}
              width={211}
              alt="logo"
              className="logo-img"
            />
          </a>
        )}
      </div>
    </section>
  );
};

export const PrivacyButton=({onPrivacyClick})=>{
  return (<Button
            as="a"
            href={`${USERDEV_BASE_URL}privacy-center`}
            target="_blank"
            rel="noopener noreferrer"
            variant="link"
            className="ad-link p-0"
            onClick={() => {
              onPrivacyClick();
            }}
          >
            Advertisement Disclosure and Privacy Policy
          </Button>)
}

export const FilterInputs = ({
  disabled,
  selected,
  handleSelect,
  formData,
  handleChange,
  handleInvestmentAmountChange,
  investmentAmount,
}) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600); 
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const smValue=isSmallScreen?'undefined':4;
  return (
    <section className="rounded-lg shadow-md mb-8 filter-inputs header-wrapper">
      <Row className="g-3">
        <Col xs={12} sm={smValue} md={4}>
          <Form.Group controlId="formInput1">
            <Form.Label className="sr-only font-weight-600 font-semibold">
              Deposit Amount
            </Form.Label>
            <div className="input-group">
              <span className="input-group-text">$</span>
              <Form.Control
                name="investmentAmount"
                type="text"
                placeholder="Enter deposit amount"
                value={investmentAmount || ""}
                disabled={disabled}
                onChange={handleInvestmentAmountChange}
                autoComplete="off"
              />
            </div>
          </Form.Group>
        </Col>

        <Col xs={5} sm={smValue} md={4}>
          <Form.Group controlId="minTerms">
            <Form.Label className="sr-only font-weight-600 font-semibold">
              Minimum Term
            </Form.Label>
            <Form.Select
              name="minTerms"
              aria-label="Default select example"
              className="rounded-md"
              disabled={disabled}
              onChange={handleChange}
              value={formData?.minTerms}
            >
              <option value="">Select Min Term</option>
              {[{ value: 5, label: "<6 month" }, ...termOptions].map(
                (option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={
                      (formData.maxTerms &&
                        parseInt(option.value, 10) > formData.maxTerms) ||
                      formData.maxTerms === 61
                    }
                  >
                    {option.label}
                  </option>
                )
              )}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col xs={5} sm={smValue} md={4}>
          <Form.Group controlId="maxTerms">
            <Form.Label className="sr-only font-weight-600 font-semibold">
              Maximum Term
            </Form.Label>
            <Form.Select
              name="maxTerms"
              aria-label="Default select example"
              className="rounded-md"
              disabled={disabled}
              onChange={handleChange}
              value={formData?.maxTerms}
            >
              <option value="">Select Max Term</option>
              {[...termOptions, { value: 61, label: "60+ month" }].map(
                (option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={
                      (formData.minTerms &&
                        parseInt(option.value, 10) < formData.minTerms) ||
                      formData.minTerms === 5
                    }
                  >
                    {option.label}
                  </option>
                )
              )}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col xs={2} sm={2} className="mobile-display sorting-ddl-wrapper">
          <Dropdown
            className="mt-4"
            disabled={disabled}
            onSelect={handleSelect}
          >
            <Dropdown.Toggle
              variant=""
              id="dropdown-basic"
              className="sorting-ddl"
            >
              <Image
                src={UpDownSorting}
                height={16}
                width={16}
                alt={"sorting"}
              />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {sortData.map((item) => {
                const key = Object.keys(item)[0];
                return (
                  <Dropdown.Item eventKey={key} active={selected === key}>
                    {key}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    </section>
  );
};

export const BankLogoImage = ({ bankLogo }) => (
  <div className="bank-logo-wrapper" >
    <img
      className="image"
      src={
        bankLogo && bankLogo !== ""
          ? `${USERDEV_BASE_URL}api/imageProxy?imageUrl=${bankLogo}`
          : "/image/no-image.svg"
      }
      alt="bank"
      height={49}
      width={70}
    />
  </div>
);

export const StarRatingSection = ({
  parentClassName = "",
  bankName,
  starRating,
  bankDescription,
}) => {
  const width = 12;
  const height = 12;
  return (
    <div className={parentClassName}>
      {starRating !== "" ? (
        <div className="d-flex align-items-center">
          <div className="rate-img">
            <img
              alt={bankName}
              src={starYellow}
              width={width}
              height={height}
            />
          </div>
          &nbsp;
          <span className="rate-value d-flex align-items-center">
            {formatRating(starRating)}
          </span>
          &nbsp;
          <span className="fdic-label d-flex align-items-center">
            BauerFinancial Rating
          </span>
        </div>
      ) : (
        <span className="rating fs-10">{bankDescription}</span>
      )}
    </div>
  );
};

export const TableHeader = ({ selectedSort, onSort, sortType }) => {
  const sortClick = (sort) => {
    const type =
      selectedSort === sort ? (sortType === "ASC" ? "DESC" : "ASC") : "DESC";
    onSort(sort, type);
  };

  return (
    <div className="table-header">
      <Row className="ms-0 me-0 header-row desktop-display">
        <Col
          className="d-flex justify-content-start header-label financial"
        >
          Financial Institutions
        </Col>
        <Col
          className="d-flex justify-content-center header-label"
          xl={2}
          lg={2}
          md={2}
          sm={2}
        >
          <span className="cursor-pointer" onClick={() => sortClick("byApy")}>
            Apy
          </span>
          &nbsp;
          <Tooltip
            tooltipId="info-tooltip"
            tooltipText={APY_TEXT}
            isMobile={false}
          >
            <FontAwesomeIcon
              icon={faInfoCircle}
              size="sm"
              className="infoIcon"
            />
          </Tooltip>
          &nbsp;
          <FontAwesomeIcon
            className={`cursor-pointer sort-arrow ${
              selectedSort === "byApy" ? "active" : ""
            }`}
            icon={
              selectedSort === "byApy"
                ? sortType === "ASC"
                  ? faArrowUp
                  : faArrowDown
                : faArrowDown
            }
            size="sm"
            onClick={() => sortClick("byApy")}
          />
        </Col>
        <Col
          className="d-flex justify-content-center header-label"
          xl={2}
          lg={2}
          md={2}
          sm={2}
        >
          <span className="cursor-pointer" onClick={() => sortClick("byTerm")}>
            Term
          </span>
          &nbsp;
          <FontAwesomeIcon
            className={`cursor-pointer sort-arrow ${
              selectedSort === "byTerm" ? "active" : ""
            }`}
            icon={
              selectedSort === "byTerm"
                ? sortType === "ASC"
                  ? faArrowUp
                  : faArrowDown
                : faArrowUp
            }
            size="sm"
            onClick={() => sortClick("byTerm")}
          />
        </Col>
        <Col
          className="justify-content-center header-label"
          xl={2}
          lg={2}
          md={2}
          sm={2}
        >
          <span
            className="cursor-pointer"
            onClick={() => sortClick("byBalance")}
          >
            Min. Deposit
          </span>
          &nbsp;
          <FontAwesomeIcon
            className={`cursor-pointer sort-arrow ${
              selectedSort === "byBalance" ? "active" : ""
            }`}
            icon={
              selectedSort === "byBalance"
                ? sortType === "ASC"
                  ? faArrowUp
                  : faArrowDown
                : faArrowUp
            }
            size="sm"
            onClick={() => sortClick("byBalance")}
          />
        </Col>
        <Col
          className="justify-content-center header-label"
          xl={2}
          lg={2}
          md={2}
          sm={2}
        >
          <span
            className="cursor-pointer"
            onClick={() => sortClick("byEarning")}
          >
            Est. Earnings
          </span>
          &nbsp;
          <Tooltip
            tooltipId="info-tooltip"
            tooltipText={EST_TEXT}
            isMobile={false}
          >
            <FontAwesomeIcon
              icon={faInfoCircle}
              size="sm"
              className="infoIcon"
            />
          </Tooltip>
          &nbsp;
          <FontAwesomeIcon
            className={`cursor-pointer sort-arrow ${
              selectedSort === "byEarning" ? "active" : ""
            }`}
            icon={
              selectedSort === "byEarning"
                ? sortType === "ASC"
                  ? faArrowUp
                  : faArrowDown
                : faArrowUp
            }
            size="sm"
            onClick={() => sortClick("byEarning")}
          />
        </Col>
      </Row>
    </div>
  );
};

export const FdicLabel = React.memo(({ bankType, className = "" }) => {
  const label = bankType === "bank" ? "Member FDIC" : "Insured by NCUA";
  return <div className={className}>{label}</div>;
});

export const DesktopViewTable = ({
  isLoading,
  rateTableData,
  isCollapsibleRestriction,
  setIsCollapsibleRestriction,
  onSort,
  selectedSort,
  sortType,
  affiliateId,
}) => {
  if (isLoading) return null;

  if (!Array.isArray(rateTableData) || rateTableData.length === 0) {
    return (
      <div className="desktop-display">
        <NoRecordSection />
      </div>
    );
  }

  return (
    <div className="desktop-display">
      <TableHeader
        selectedSort={selectedSort}
        sortType={sortType}
        onSort={onSort}
      />
      {rateTableData.map((rate) => (
        <StyledCustomCard key={rate?._id}>
          <Row className="data-row align-items-center m-1  card-desktopview">
            <Col className="d-flex justify-content-between card-financial">
              <div className="d-flex align-items-center">
                <BankLogoImage bankLogo={rate?.bankLogo} />
                <div className="ms-3 bank-detail-wrapper ">
                  <FdicLabel bankType={rate?.bankType} className="fdic-label" />
                  <div className="bank-title">{rate?.bankName}</div>
                  <div className="star-section-desktop">
                  <StarRatingSection
                    bankName={rate?.bankName}
                    starRating={rate?.starRating}
                    bankDescription={rate?.bankDescription}
                  />
                  </div>
                </div>
              </div>
            </Col>

            <Col
              xl={2}
              lg={2}
              md={2}
              sm={2}
              className="d-flex justify-content-center"
            >
              <div className="d-flex align-item-center">
                <span className="apy-value">{formatRating(rate?.apy, 2)}%</span>
              </div>
            </Col>

            <Col
              xl={2}
              lg={2}
              md={2}
              sm={2}
              className="d-flex justify-content-center"
            >
              <div className="apy-value">{formatTerms(rate?.termInMonths)}</div>
            </Col>

            <Col
              xl={2}
              lg={2}
              md={2}
              sm={2}
              className="d-flex justify-content-center"
            >
              <div className="apy-value">
                {formatBalance(rate?.minBalance, "minDeposit")}
              </div>
            </Col>

            <Col
              xl={2}
              lg={2}
              md={2}
              sm={2}
              className="d-flex justify-content-center"
            >
              <div className="est-earnings">
                {formatBalance(rate?.estimatedEarning)}
              </div>
            </Col>
            <Col className="d-flex justify-content-end desktop-view">
              <div className="star-section">
                <StarRatingSection
                  bankName={rate?.bankName}
                  starRating={rate?.starRating}
                  bankDescription={rate?.bankDescription}
                />
              </div>
              <OpenNowButton Apply={rate} placeSource="Widget" />
            </Col>

            <Col xs={12} className="p-0 desktop-view-badges">
              <Row className={`badges-row g-0 align-items-center mt-2 mb-1`}>
                <Col
                  xl={10}
                  lg={10}
                  md={10}
                  sm={8}
                  className="pe-3 desktop-view"
                >
                  <div>
                    <Badge className="month-badge font-weight-500">
                      {rate?.terms}
                    </Badge>
                    &nbsp;
                    <Badge className="apy-badge font-weight-500">
                      Updated APY {formateDate(rate?.updatedAt)}
                    </Badge>
                  </div>
                </Col>
                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={4}
                  className="d-flex justify-content-center action-col desktop-view"
                >
                  {rate?.isRestrictions && (
                    <div className="restriction-toggle">
                      <Restrictions
                        isCollapsibleRestriction={
                          rate?._id === isCollapsibleRestriction
                        }
                        setIsCollapsibleRestriction={() => {
                          setIsCollapsibleRestriction(
                            rate?._id === isCollapsibleRestriction
                              ? ""
                              : rate?._id
                          );
                          trackEvent("Affiliate_Open_Now_Restriction", {
                            ...rate,
                            affiliateId,
                          });
                        }}
                        affiliateId={affiliateId}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
            <div className="restriction-desktop-view">
              <RestrictionCollapseContent
                isShow={rate?._id === isCollapsibleRestriction}
                data={rate?.restrictions}
              />
            </div>
          </Row>

          {/* -------------------------------Tablet-View---------------------------------- */}

          <Row className="data-row align-items-center m-1 tablet-view px-0">
            <Col className="d-flex justify-content-end  ">
              <OpenNowButton Apply={rate} placeSource="Widget" />
            </Col>

            <Col xs={12} className="p-0">
              <Row className={`badges-row g-0 align-items-center`}>
                <Col xl={10} lg={10} md={10} sm={8} className="pe-3">
                  <div>
                    <Badge className="month-badge font-weight-500">
                      {rate?.terms}
                    </Badge>
                    &nbsp;
                    <Badge className="apy-badge font-weight-500">
                      Updated APY {formateDate(rate?.updatedAt)}
                    </Badge>
                  </div>
                </Col>

                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={4}
                  className="d-flex justify-content-center action-col"
                >
                  {rate?.isRestrictions && (
                    <div className="restriction-toggle">
                      <Restrictions
                        isCollapsibleRestriction={
                          rate?._id === isCollapsibleRestriction
                        }
                        setIsCollapsibleRestriction={() => {
                          setIsCollapsibleRestriction(
                            rate?._id === isCollapsibleRestriction
                              ? ""
                              : rate?._id
                          );
                          trackEvent("Affiliate_Open_Now_Restriction", {
                            ...rate,
                            affiliateId,
                          });
                        }}
                        affiliateId={affiliateId}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
            <RestrictionCollapseContent
              isShow={rate?._id === isCollapsibleRestriction}
              data={rate?.restrictions}
            />
          </Row>
        </StyledCustomCard>
      ))}
    </div>
  );
};

export const MobileViewTable = ({
  isLoading,
  rateTableData,
  isCollapsibleRestriction,
  setIsCollapsibleRestriction,
  affiliateId,
}) => {
  if (isLoading) return null;
  return (
    <div className="mobile-display">
      {!isLoading && !rateTableData.length ? <NoRecordSection /> : ""}
      {rateTableData?.map((rate) => (
        <StyledCustomCard className="mt-3 mobile-data-row " key={rate?._id}>
          <Row>
            <Col
              xl={4}
              lg={4}
              md={4}
              sm={12}
              className="d-flex justify-content-between"
            >
              <div className="d-flex align-items-center">
                <BankLogoImage
                  bankLogo={rate?.bankLogo}
                />
                <div className="ms-3 bank-detail-wrapper ">
                  <FdicLabel bankType={rate?.bankType} className="fdic-label" />
                  <div
                    className="bank-title "
                  >
                    {rate?.bankName}
                  </div>
                  <StarRatingSection
                    bankName={rate?.bankName}
                    starRating={rate?.starRating}
                    bankDescription={rate?.bankDescription}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="d-flex justify-content-between mb-2">
            <Col sm={6} xs={6}>
              <div className="label-value">
                APY&nbsp;
                <Tooltip
                  tooltipId="info-tooltip"
                  tooltipText={APY_TEXT}
                  isMobile
                >
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    size="sm"
                    className="mobileInfoIcon"
                  />
                </Tooltip>
              </div>
              <div className="apy-value">
                {formatRating(rate?.apy, 2)}
                <span>&#37;</span>
              </div>
            </Col>
            <Col sm={6} xs={6}>
              <div className="label-value term">Term</div>
              <div className="apy-value term">
                {formatTerms(rate?.termInMonths)}
              </div>
            </Col>
          </Row>

          <Row className="d-flex justify-content-between mb-2">
            <Col sm={6} xs={6}>
              <div className="label-value">Minimum Deposit</div>
              <div className="apy-value">
                {formatBalance(rate?.minBalance, "minDeposit")}
              </div>
            </Col>
            <Col sm={6} xs={6} >
              <div className="label-value est">
                Estimated Earnings&nbsp;
                <Tooltip
                  tooltipId="est-info-tooltip"
                  tooltipText={EST_TEXT}
                  isMobile
                >
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    size="sm"
                    className="mobileInfoIcon"
                  />
                </Tooltip>
              </div>
              <div className="est-earnings est">
                {formatBalance(rate?.estimatedEarning)}
              </div>
            </Col>
          </Row>

          <Row className="d-flex justify-content-between mb-3 align-items-end">
            <Col sm={6} xs={6}>
              {rate?.isRestrictions && (
                <Restrictions
                  isCollapsibleRestriction={
                    rate?._id === isCollapsibleRestriction
                  }
                  setIsCollapsibleRestriction={() => {
                    setIsCollapsibleRestriction(
                      rate?._id === isCollapsibleRestriction ? "" : rate?._id
                    );
                    trackEvent("Affiliate_Open_Now_Restriction", {
                      ...rate,
                      affiliateId,
                    });
                  }}
                  isMobile
                  affiliateId={affiliateId}
                />
              )}
            </Col>
            <Col sm={6} xs={6}>
              <OpenNowButton
                Apply={rate}
                placeSource="Widget"
                affiliateId={affiliateId}
              />
            </Col>
          </Row>

          {rate?._id === isCollapsibleRestriction && (
            <Row>
              <Col sm={12} xs={12}>
                <RestrictionCollapseContent isShow data={rate?.restrictions} />
              </Col>
            </Row>
          )}

          <div className="d-flex mb-2 align-items-center updated-apy">
            {rate?.terms && (
              <div
                style={{
                  width:
                    rate?.terms && formateDate(rate?.updatedAt)
                      ? "48%"
                      : "100%",
                }}
              >
                {rate?.terms} Adjustable Rate New $ Special
              </div>
            )}
            {formateDate(rate?.updatedAt) && (
              <div
                className={`${
                  rate?.terms && formateDate(rate?.updatedAt)
                    ? "second d-flex"
                    : ""
                }`}
              >
                Updated APY: {formateDate(rate?.updatedAt)}
              </div>
            )}
          </div>
        </StyledCustomCard>
      ))}
    </div>
  );
};

export const Restrictions = ({
  isCollapsibleRestriction,
  setIsCollapsibleRestriction,
  isMobile = false,
  affiliateId,
}) => {
  const imgClassName = !isMobile ? "ms-2" : "ms-1";
  return (
    <div>
      <div
        className="btn-restriction d-flex align-items-center"
        onClick={() => {
          setIsCollapsibleRestriction();
          trackEvent("Affiliate_Open_Now_Restriction", { affiliateId });
        }}
      >
        {" "}
        Restrictions
        {!isCollapsibleRestriction ? (
          <Image
            src={restrictionDownArrow}
            className={imgClassName}
            alt="down"
            width="12px"
            height="7px"
          />
        ) : (
          <Image
            src={restrictionUpArrow}
            className={imgClassName}
            alt="up"
            width="12px"
            height="7px"
          />
        )}
      </div>
    </div>
  );
};

export const RestrictionCollapseContent = ({ isShow, data }) => {
  if (!isShow) return <></>;
  return (
    <Collapse in={true}>
      <div className="collapsible-visible mt-2 d-block justify-content-between pe-0 card card-body">
        <div className="restriction-content" dangerouslySetInnerHTML={{ __html: data }} />
      </div>
    </Collapse>
  );
};

export const Footer = ({
  isShowPagination,
  currentIndex,
  totalPages,
  setPagination,
  isLoading,
  showLogo = true,
  logoClick,
}) => {
  return (
    <div className="footer-section d-flex flex-column flex-lg-row align-items-center justify-content-lg-between gap-2">
      <div className="footer-content-label">
        {showLogo && (
          <>
            <span>Looking for local rates and exclusive offers? </span>
            <span className="footer-logo d-flex align-items-center">
              <span className="me-2">Visit</span>
              <a
                href={USERDEV_BASE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open CD Valet website in a new tab"
                className="d-inline-flex"
                onClick={logoClick}
              >
                <Image
                  className="cursor-pointer"
                  src={logoupdated}
                  height={20}
                  width={100}
                  alt="CD Valet"
                />
              </a>
            </span>
          </>
        )}
      </div>
      <div className="pagination-content">
        {isShowPagination && totalPages > 1 && (
          <nav>
            <span>
              Page {currentIndex} of {totalPages}
            </span>
            &nbsp; &nbsp;
            <StyledButton
              type="button"
              variant="light"
              className="left-btn"
              aria-label="Previous page"
              disabled={isLoading || currentIndex <= 1}
              onClick={() =>
                currentIndex > 1 &&
                setPagination(currentIndex - 1, "back_forward")
              }
            >
              <Image src={LeftArrow} height={16} width={16} alt="Previous" />
            </StyledButton>
            &nbsp;
            <StyledButton
              type="button"
              variant="light"
              className="right-btn"
              aria-label="Next page"
              disabled={isLoading || currentIndex >= totalPages}
              onClick={() =>
                currentIndex < totalPages &&
                setPagination(currentIndex + 1, "forward")
              }
            >
              <Image src={RightArrow} height={16} width={16} alt="Next" />
            </StyledButton>
          </nav>
        )}
      </div>
    </div>
  );
};
